<template>
  <div class="pages-vacancies-form">
    <BundlesHead
      :title="$t('vacancies.form.title')"
      :subtitle="$t('vacancies.wantWork')"
      :back-text="$t('vacancies.singleVacancy.back')"
      back-url="/vacancies"
    />

    <CtrSidebar icon="/images/pen.svg">
      <template #content>
        <CtrVacancyForm in-sidebar />
      </template>
    </CtrSidebar>
  </div>
</template>

<style scoped lang="scss">
.pages-vacancies-form {
  padding-top: em($gap-page-title);
  padding-bottom: em(160);

  @include media-breakpoint-down(sm) {
    padding-top: em($gap-page-title-sm);
    padding-bottom: em(74);
  }
}
</style>
